export enum MaxUsageType {
    NONE = 1,
    LIMITED = 2,
}

